import { AxiosPromise } from 'axios';
import { axios } from 'src/app/utils';

import { urlsConfig } from 'src/configs';
import { serviceLocals } from 'src/locals';
import { queryTypes, reduxRootTypes, serviceIncidentFolderTypes, serviceIncidentTypes } from 'src/types';
import { fileHelper, urlHelper } from '../helpers';

export const downloadAttachment = async ({ path, token, attachment }: any) => {
  const attachmentUrl = urlHelper.addQueryParameters({ path, token }, `${urlsConfig.storageServerURL}`);

  const data = await fetch(attachmentUrl);

  const dataBlob = await data.blob();
  const dataURL = URL.createObjectURL(dataBlob);
  const link = document.createElement('a');
  link.href = dataURL;
  link.download = `${attachment.name}`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const getAttachmentUrl = ({ path, token }: any) => {
  return urlHelper.addQueryParameters({ path, token }, `${urlsConfig.storageServerURL}`);
};
